import { searchSuggestionsApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { Search } from 'lucide-react';

function SearchBox({handleSubmit, size, placeholder, variant = null}) {
  const { makeApiCallFunc } = useContext(Context);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchSuggestionsArr, setSearchSuggestionsArr] = useState([]);
  const searchSuggestions = () => 
  {
    makeApiCallFunc(
      searchSuggestionsApi, 
      {searchText : searchTerm}, 
      (data) => {
      console.log(data);
      setSearchSuggestionsArr(data);
    },
    (error) => console.log(error),
    null,
    true
    )}
  const handleKeyDown = (event) => {
    // if(event.target.value.length > 5)
    // {
    //   searchSuggestions();
    // }
    if (event.key === 'Enter') 
    {
      handleSubmit(searchTerm);

    }
};
  if (variant === 'dark') {
    // Design 18c nav search: translucent box on navy
    return (
      // Case List design header search: 220px, outline only
      <div className="flex items-center font-plexsans" style={{gap:'8px', padding:'10px 14px', border:'1px solid rgba(247,244,237,.25)', borderRadius:'5px', width:'220px'}}>
        <Search size={14} strokeWidth={2} color="rgba(247,244,237,.55)" className="flex-none"/>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value.trim())}
          placeholder={placeholder ? placeholder : "Search"}
          onKeyDown={handleKeyDown}
          className="bg-transparent outline-none flex-1 min-w-0 truncate text-[#f7f4ed] placeholder:text-[rgba(247,244,237,0.5)]"
          style={{font:"400 13px/1 'IBM Plex Sans',sans-serif"}}
        />
      </div>
    );
  }
  if (variant === 'light') {
    // light box used in the mobile case list bar
    return (
      <div className="flex items-center font-plexsans" style={{gap:'8px', padding:'10px 12px', border:'1px solid rgba(20,33,61,.18)', borderRadius:'6px', background:'#fff', width:'100%'}}>
        <Search size={14} strokeWidth={2} color="rgba(20,33,61,.45)" className="flex-none"/>
        <input
          type="text"
          autoFocus
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value.trim())}
          placeholder={placeholder ? placeholder : "Search"}
          onKeyDown={handleKeyDown}
          enterKeyHint="search"
          className="bg-transparent outline-none flex-1 min-w-0 truncate text-[#14213d] placeholder:text-[rgba(20,33,61,0.4)]"
          style={{font:"400 14px/1.2 'IBM Plex Sans',sans-serif"}}
        />
      </div>
    );
  }
  return (
    <div className={(size === 'l' ? "w-full " : "") + " flex flex-col" }>
    <div className={(size === 'l' ? ' bg-white p-10 lg:border border-b w-full ' : '') + " flex items-center  rounded shadow-sm  bg-gray-100 p-1 py-2 pl-2  flex-grow min-w-[80px] "}>
      <FaSearch className={"text-gray-400 mr-2 h-[14px] w-[14px]"} />
      <input
        type="text"
        value = {searchTerm}
        onChange = {(e) => setSearchTerm(e.target.value.trim())}
        placeholder={placeholder ? placeholder : "Search"}
        className={(size === 'l' ? ' h-[40px]  rounded bg-white  lg:text-base text-xs w-full  ' : ' text-sm ') +  "  outline-none flex-1 bg-gray-100 truncate "}
        onKeyDown={handleKeyDown} 
      />
    </div>
      {
        searchSuggestionsArr.length > 0 && 
        <div className='flex flex-col w-full bg-gray-100 p-2 rounded mt-2'>
          {
            searchSuggestionsArr.map((suggestion, key) => {
              return (
                <div key={key} className='flex justify-between items-center p-1 bg-white rounded'>
                  <div>{suggestion}</div>
                  <div className='bg-green-600 text-white rounded p-1 cursor-pointer'>View</div>
                </div>
              )
            })
          }
        </div>
      }
    </div>
  );
}

export default SearchBox;